var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "제품 및 솔루션",
      "sc": "에프원시큐리티는 다방면으로 파트너의 정보를 보호합니다",
      "tabActive": "F1 WMDS",
      "icon": "/images/sub/visual/sv3-icon.svg",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section-sm sub-section-sm--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-28 mb-lg-54"
  }, [_c('h3', {
    staticClass: "sub-tit--lg text-center mb-12 mb-lg-24",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 악성코드 유포·경유 웹사이트(홈페이지)란? ")]), _c('p', {
    staticClass: "page-text--lg color-gray text-center"
  }, [_vm._v(" 이용자가 브라우저로 접속하면 악성코드에 감염될 수 있는 대단히 위험한 웹사이트 입니다. "), _c('br'), _vm._v(" 최근 사회적 문제로 이슈화된 랜섬웨어 같은 악성코드 역시 이같은 웹사이트에 접속하는 것만으로 감염됩니다. ")])]), _c('div', {
    staticClass: "w-100 pa-30 pb-md-40 mb-40 mb-lg-80 bg-grey-full"
  }, [_c('v-img', {
    staticClass: "d-block mx-auto",
    attrs: {
      "max-width": "598",
      "src": "/images/sub/products/wmds/s1-img1.png"
    }
  })], 1), _c('h4', {
    staticClass: "line-txt",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 우리 기업의 웹사이트에서 악성코드가 유포·경유되면? ")]), _c('v-row', {
    staticClass: "mx-lg-n44"
  }, [_c('v-col', {
    staticClass: "px-lg-44 mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "process-3dep1 w-100 h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('div', {
    staticClass: "radius-lg bg-grey h-100"
  }, [_c('v-img', {
    staticClass: "d-block w-100",
    attrs: {
      "max-width": "1024",
      "src": "/images/sub/products/wmds/s1-img2-1.png"
    }
  }), _c('div', {
    staticClass: "pa-16 py-md-46"
  }, [_c('p', {
    staticClass: "page-text-sm color-grey-49 text-center"
  }, [_vm._v(" 웹사이트가 해킹 당하는 순간에는 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 피해자이지만 악성코드를 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('span', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("유포 • 경유시키는 순간 가해자")]), _vm._v("가 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 되어버립니다. ")])])], 1)])]), _c('v-col', {
    staticClass: "px-lg-44 mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "process-3dep2 w-100 h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "400"
    }
  }, [_c('div', {
    staticClass: "radius-lg bg-grey h-100"
  }, [_c('v-img', {
    staticClass: "d-block w-100",
    attrs: {
      "max-width": "1024",
      "src": "/images/sub/products/wmds/s1-img2-2.png"
    }
  }), _c('div', {
    staticClass: "pa-16 py-md-46"
  }, [_c('p', {
    staticClass: "page-text-sm color-grey-49 text-center"
  }, [_vm._v(" 정보통신망법의 적용 대상인 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 사업체는 법에서 요구하는 보안 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 조치가 미흡했다는 이유로 정부 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 단속 및 "), _c('span', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("과태료 / 과징금 부과대상")]), _vm._v("이 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 될 수 있습니다. ")])])], 1)])]), _c('v-col', {
    staticClass: "px-lg-44",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "process-3dep3 w-100 h-100",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "700"
    }
  }, [_c('div', {
    staticClass: "radius-lg bg-grey h-100 process-3dep3"
  }, [_c('v-img', {
    staticClass: "d-block w-100",
    attrs: {
      "max-width": "1024",
      "src": "/images/sub/products/wmds/s1-img2-3.png"
    }
  }), _c('div', {
    staticClass: "pa-16 py-md-46"
  }, [_c('p', {
    staticClass: "page-text-sm color-grey-49 text-center"
  }, [_vm._v(" 악성코드에 감염된 사용자들로부터 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _c('span', {
    staticClass: "font-weight-bold color-point"
  }, [_vm._v("집단소송분쟁")]), _vm._v("에 휘말릴 수도 있어 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 기관 / 기업 이미지에 심각한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 타격을 줍니다. ")])])], 1)])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section-sm"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" F1-WMDS "), _c('br'), _vm._v(" Web Malware Detection System란? ")]), _c('div', {
    staticClass: "bg-grey-full pa-30 pa-md-70 mb-30 mb-lg-70"
  }, [_c('v-img', {
    staticClass: "d-block mx-auto",
    attrs: {
      "max-width": "820",
      "src": "/images/sub/products/wmds/s2-img1.png"
    }
  })], 1), _c('div', {
    staticClass: "bg-white border-light radius-md"
  }, [_c('div', {
    staticClass: "border-bottom border-color-light pa-16 pa-md-0"
  }, [_c('v-img', {
    staticClass: "tb mx-auto",
    attrs: {
      "max-width": "1200",
      "src": "/images/sub/products/wmds/s2-img2.png"
    }
  }), _c('v-img', {
    staticClass: "mo mx-auto",
    attrs: {
      "max-width": "561",
      "src": "/images/sub/products/wmds/s2-img2-mo.png"
    }
  })], 1), _c('v-row', {
    staticClass: "bg-grey",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "border-right border-color-light d-flex align-center pa-16 px-md-50 py-lg-20",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-img', {
    staticClass: "d-block mr-10 mr-lg-20",
    attrs: {
      "max-width": "90",
      "src": "/images/sub/products/wmds/s2-icon1-1.png"
    }
  }), _c('div', [_c('p', {
    staticClass: "page-text-sm color-grey-49 line-height-12"
  }, [_c('span', {
    staticClass: "font-weight-bold d-inline-block mb-2 mb-lg-4"
  }, [_vm._v("공격자(해커)")]), _vm._v(" "), _c('br'), _vm._v(" 의도적 공격으로 보안 취약점을 이용한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 악성코드 삽입 ")])])], 1), _c('v-col', {
    staticClass: "d-flex align-center pa-16 px-md-50 py-lg-20",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-img', {
    staticClass: "d-block mr-10 mr-lg-20",
    attrs: {
      "max-width": "90",
      "src": "/images/sub/products/wmds/s2-icon1-2.png"
    }
  }), _c('div', [_c('p', {
    staticClass: "page-text-sm color-grey-49 line-height-12"
  }, [_c('span', {
    staticClass: "font-weight-bold d-inline-block mb-2 mb-lg-4"
  }, [_vm._v("협력사")]), _vm._v(" "), _c('br'), _vm._v(" 비의도적인 공격으로 협력사 등에서 제작한 컨텐츠에 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 이미 악성코드가 삽입된 상태로 업로드 ")])])], 1)], 1)], 1)])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 악성코드 경유·유포 사이트를 통한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 사고 탐지에 최적화되어 있습니다. ")]), _c('h4', {
    staticClass: "line-txt",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 특장점 요약 ")]), _c('v-row', {
    staticClass: "mb-40 mb-lg-86"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-sm card pa-16 py-md-50 px-md-34 h-100 border",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18"
  }, [_vm._v(" 01 ")]), _c('h6', {
    staticClass: "page-text-lg font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 외부링크 추적 ")]), _c('p', {
    staticClass: "page-text-sm color-grey-49"
  }, [_vm._v(" 외부링크를 인식하고 추적하여 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 유포지까지 경로 추적 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-sm card pa-16 py-md-50 px-md-34 h-100 border",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "400"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18"
  }, [_vm._v(" 02 ")]), _c('h6', {
    staticClass: "page-text-lg font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 최신 DB 패턴 적용 ")]), _c('p', {
    staticClass: "page-text-sm color-grey-49"
  }, [_vm._v(" 악성코드 유포지/경유지 DB 패턴 최신화 제공 "), _c('br'), _vm._v(" (한국인터넷진흥원, 자체분석인력 보유등) ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-sm card pa-16 py-md-50 px-md-34 h-100 border",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "700"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18"
  }, [_vm._v(" 03 ")]), _c('h6', {
    staticClass: "page-text-lg font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 운영 편리성 ")]), _c('p', {
    staticClass: "page-text-sm color-grey-49"
  }, [_vm._v(" 점검대상 웹사이트 Depth와 페이지수 설정 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 가능 등 편리한 운영환경 제공 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-sm card pa-16 py-md-50 px-md-34 h-100 border",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1000"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18"
  }, [_vm._v(" 04 ")]), _c('h6', {
    staticClass: "page-text-lg font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 난독화 처리 ")]), _c('p', {
    staticClass: "page-text-sm color-grey-49"
  }, [_vm._v(" Javascript 난독화 처리 기술을 이용한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 은닉된 유포코드 탐지 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-sm card pa-16 py-md-50 px-md-34 h-100 border",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1300"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18"
  }, [_vm._v(" 05 ")]), _c('h6', {
    staticClass: "page-text-lg font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 웹 서비스 안정성 유지 ")]), _c('p', {
    staticClass: "page-text-sm color-grey-49"
  }, [_vm._v(" 365X24시간 악성코드 유포 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 삽입 탐지 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "radius-sm card pa-16 py-md-50 px-md-34 h-100 border",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "1600"
    }
  }, [_c('p', {
    staticClass: "font-size-14 font-size-lg-20 line-height-1 font-weight-bold color-point mb-8 mb-lg-18"
  }, [_vm._v(" 06 ")]), _c('h6', {
    staticClass: "page-text-lg font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 간편한 등록 ")]), _c('p', {
    staticClass: "page-text-sm color-grey-49"
  }, [_vm._v(" Non-Agent 로 도메인만 등록하면 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 사용이 가능 ")])])])], 1), _c('h4', {
    staticClass: "line-txt",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 주요 대상고객 ")]), _c('v-row', {
    staticClass: "radius-lg",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-16 py-lg-48 bg-img d-lg-flex align-center justify-center",
    staticStyle: {
      "background-image": "url(/images/sub/products/wmds/s3-img1-1.png)"
    },
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticStyle: {}
  }, [_c('h6', {
    staticClass: "page-text-lg color-white mb-4 mb-lg-32"
  }, [_vm._v(" 방문 고객 보호 및 신뢰성 유지 ")]), _c('p', {
    staticClass: "page-text-sm color-white font-weight-bold"
  }, [_vm._v(" 공공기관 ")])])]), _c('v-col', {
    staticClass: "pa-16 py-lg-48 pl-lg-60 bg-img",
    staticStyle: {
      "background-image": "url(/images/sub/products/wmds/s3-img1-2.png)"
    },
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('h6', {
    staticClass: "page-text-lg color-gery-57 mb-4 mb-lg-8"
  }, [_vm._v(" 보안관제 업체, 웹호스팅 업체, IDC, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 그룹/계열사 보안관리조직, CERT조직 등 ")]), _c('p', {
    staticClass: "page-text-sm color-point font-weight-bold"
  }, [_vm._v(" 대규모 웹사이트 보안관리 조직 ")])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section-sm"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title mb-32 mb-lg-56"
  }, [_c('h3', {
    staticClass: "sub-tit--md text-center mb-12 mb-lg-24",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" F1-WMDS 솔루션 "), _c('br'), _vm._v(" (Web Malware Detection System) ")]), _c('p', {
    staticClass: "page-text-lg text-center"
  }, [_vm._v(" 웹사이트에 멀웨어를 배포하는 코드가 삽입되는지를 주기적으로 검사하고 악성코드가 배포되기 전에 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 미리 탐지하여 시스템관리자 또는 관제시스템에 알려 선 조치를 취하기 위한 시스템 입니다. ")])]), _c('div', {
    staticClass: "s2-box border-light bg-white radius-md"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "border-right border-color-light",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('p', {
    staticClass: "py-10 page-text-sm font-weight-bold color-point text-center border-bottom border-color-light bg-grey"
  }, [_vm._v(" 침해사고 탐지/대응강화 ")]), _c('div', {
    staticClass: "pa-16 py-md-24"
  }, [_c('p', {
    staticClass: "color-grey-49 page-text-sm text-center"
  }, [_vm._v(" 신규/변경 되는 웹서비스 Contents에 대한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 주기적인 점검으로 사고예방 및 대응 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('p', {
    staticClass: "py-10 page-text-sm font-weight-bold color-point text-center border-bottom border-color-light bg-grey"
  }, [_vm._v(" 웹서비스 연속성 보장 ")]), _c('div', {
    staticClass: "pa-16 py-md-24"
  }, [_c('p', {
    staticClass: "color-grey-49 page-text-sm text-center"
  }, [_vm._v(" Non-Agent 구현 및 네트워크 구성에 영향을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 주지 않음으로써 웹서비스 연속성 보장 ")])])])], 1), _c('p', {
    staticClass: "w-100 bg-point color-white text-center font-weight-bold page-text-lg pa-14 border-top border-bottom border-color-light"
  }, [_vm._v(" 웹 기반 악성코드 유포공격 대응 전용 탐지 솔루션 ")]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "border-right border-color-light",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "bg-grey py-10"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/arrow-bottom.png"
    }
  })], 1), _c('div', {
    staticClass: "pa-16 py-md-50 border-top border-color-light"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block mb-8 mb-lg-20",
    attrs: {
      "max-width": "69",
      "src": "/images/sub/products/wmds/s4-icon1-1.png"
    }
  }), _c('p', {
    staticClass: "page-text-lg line-height-1 font-weight-bold text-center"
  }, [_vm._v("편리한 사용")])], 1)]), _c('v-col', {
    staticClass: "border-right border-color-light",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "bg-grey py-10 d-none d-lg-block"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/arrow-bottom.png"
    }
  })], 1), _c('div', {
    staticClass: "pa-16 py-md-50 border-top border-color-light"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block mb-8 mb-lg-20",
    attrs: {
      "max-width": "69",
      "src": "/images/sub/products/wmds/s4-icon1-2.png"
    }
  }), _c('p', {
    staticClass: "page-text-lg line-height-1 font-weight-bold text-center"
  }, [_vm._v("웹서버 보안성 강화")])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "bg-grey py-10 d-none d-lg-block"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/arrow-bottom.png"
    }
  })], 1), _c('div', {
    staticClass: "pa-16 py-md-50 border-top border-color-light"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block mb-8 mb-lg-20",
    attrs: {
      "max-width": "69",
      "src": "/images/sub/products/wmds/s4-icon1-3.png"
    }
  }), _c('p', {
    staticClass: "page-text-lg line-height-1 font-weight-bold text-center"
  }, [_vm._v("간편한 운영")])], 1)])], 1)], 1)])], 1), _c('section', {
    staticClass: "sub-section-sm sub-section--last"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 악성코드 경유·유포 사이트를 통한 "), _c('br'), _vm._v(" 사고 탐지에 최적화되어 있습니다. ")]), _c('h4', {
    staticClass: "line-txt",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" WMDS 특장점 ")]), _c('div', {
    staticClass: "radius-lg bg-grey mb-40 mb-lg-80 tb"
  }, [_c('v-img', {
    staticClass: "w-100 d-block",
    attrs: {
      "max-width": "1200",
      "src": "/images/sub/products/wmds/s5-img1.png"
    }
  })], 1), _c('div', {
    staticClass: "mb-40 mo"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "400",
      "src": "/images/sub/products/wmds/s5-img1-mo.png"
    }
  })], 1), _c('h4', {
    staticClass: "line-txt"
  }, [_vm._v(" F1-WMDS 기대효과 ")]), _c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "1197",
      "src": "/images/sub/products/wmds/s5-img2.png"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }